// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__38cIp","title":"AfterFrontImage_title__73gGO"};